var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_328_800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19V1H-0.5V19H17.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_328_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.007 18.1384H3.00329C1.97269 18.1384 1.13721 17.3029 1.13721 16.2723V8.60655L7.63922 2.21609C8.11986 1.74365 8.89043 1.74365 9.37107 2.21609L15.8731 8.60655V16.2723C15.8731 17.3029 15.0376 18.1384 14.007 18.1384Z",
    stroke: "#1C587A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6107 10.1595V7.81156H7.38911V10.1595H5.04102V12.3811H7.38911V14.729H9.6107V12.3811H11.9585V10.1595H9.6107Z",
    stroke: "#1C587A",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinics);
export default __webpack_public_path__ + "static/media/clinics.bc8892ac226ddb90a62b1b7acdd3417b.svg";
export { ForwardRef as ReactComponent };